module.exports = __webpack_public_path__ + "static/media/shop-30@2x.f8ea26e3.jpg";